/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */
import * as React from 'react';
import { Heading} from '@vaisala/rockhopper-components';
import { useTranslation } from 'react-i18next';
import './ProductRecommendations.scss';
import { Product } from '../../modules/calculator/ProductRecommendationFunctions';
import { Hidden } from 'react-grid-system';
import MainBanner from './MainBanner';
import LanguageController from '../../modules/LanguageController';

interface ProductRecommendationsProps {
  variant: 'mobile' | 'desktop' | 'tablet';
  advanced: boolean;
  recommendedProducts: Product[]
}

const ProductRecommendations = ({ variant, advanced, recommendedProducts }: ProductRecommendationsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Heading level="2" className="product-recommendations-heading">{t('ui.recommended.header')}</Heading>
      <div className={`product-recommendations-wrap ${variant} ${advanced ? 'advanced' : 'basic'} ${(recommendedProducts.length < 1) ? 'no-recommendations' : ''}`}>
        <Hidden xs sm md>
          <MainBanner variant="desktop" />
        </Hidden>
        {recommendedProducts.map((product, i) => {
          return (
            <div className="product-card" key={i}>
              <div className="product-recommendation">
                <a className="product-recommendation-link" href={product.productLink} target="_blank" rel="noreferrer">
                  <img className="product-image" src={`/product_images/${product.imageUrl}`} alt={product.heading[LanguageController.extractLanguageCode()]}></img>
                  <div className="text-content">
                    <Heading level="4">{product.heading[LanguageController.extractLanguageCode()]}</Heading>
                    <p>{product.body[LanguageController.extractLanguageCode()]}</p>
                  </div>
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
export default ProductRecommendations;
